// extracted by mini-css-extract-plugin
export default {"manualServiceWrap":"manualServiceWrap___MykVs","closeIcon":"closeIcon___cVobd","titleIcon":"titleIcon___m17Z_","title":"title___fJyEv"};